module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "_idgenobjectstyleoverride",
    attrs: {
      "id": "_idContainer1347"
    }
  }, [_c('p', {
    staticClass: "body_introduction",
    attrs: {
      "id": "calibre_pb_57"
    }
  }, [_vm._v("I like to do breakfast big on the weekends, and this hash is like a clean keto version of something you might find on a diner menu. Plus, who doesn’t want to eat meatballs for breakfast?")]), _vm._v(" "), _c('p', {
    staticClass: "body_instruction-next-para1"
  }, [_c('span', {
    staticClass: "bold1"
  }, [_vm._v("Make the cauliflower hash")]), _vm._v(" by preheating a 10-inch nonstick pan just above medium heat with 2 tablespoons of avocado oil. Place the thawed cauliflower rice in a kitchen towel and squeeze as much water out as possible, then add the cauliflower to the pan along with ½ teaspoon of salt and a couple of cracks of pepper. Flatten the riced cauliflower with a spatula and allow to cook for 4 to 5 minutes until golden brown. Mix up the rice and flatten again, cook another 4 to 5 minutes. Keep doing this until the mixture is deep golden brown, remove from heat and "), _c('span', [_vm._v("keep")]), _c('span'), _c('span', [_vm._v("warm.")])]), _vm._v(" "), _c('p', {
    staticClass: "body_instruction-next-para1"
  }, [_c('span', {
    staticClass: "bold1"
  }, [_vm._v("Make the mini meatballs")]), _vm._v(" while the hash is cooking. Preheat a large nonstick pan over medium heat for 2 minutes with 2 teaspoons of avocado oil. Season the turkey with ½ teaspoon of salt and a few cracks of pepper and mix well. Form mini meatballs by dipping your hands in cold water and rolling them (this will prevent the mixture from sticking to your hands). Make sure they are small or they won’t cook through. Add the meatballs to the pan and cook until crusty on all sides and cooked through—about 8 minutes. Remove meatballs and "), _c('span', [_vm._v("keep")]), _c('span'), _c('span', [_vm._v("warm.")])]), _vm._v(" "), _c('p', {
    staticClass: "body_instruction-next-para1"
  }, [_vm._v("Raise the heat to medium-high, add a shot of oil to the same pan, and add the peppers. Cook until slightly charred, about 5 to 6 minutes, then add the spinach and cook until wilted, about 1 minute. Add ¼ teaspoon of salt and a few cracks of pepper, turn off the heat, and"), _c('span', [_vm._v(" mix")]), _c('span'), _c('span', [_vm._v("well.")])]), _vm._v(" "), _c('p', {
    staticClass: "body_instruction-next-para1"
  }, [_c('span', {
    staticClass: "bold1"
  }, [_vm._v("To fry the eggs")]), _vm._v(", add enough oil to coat the bottom of an 8-inch nonstick pan and preheat over medium-high. Once the oil is hot, add two eggs to the pan and season with a pinch of salt and a crack of pepper. Fry until the egg whites are golden on the bottom then tip the pan and spoon hot oil around the egg whites so they cook through. Carefully remove eggs fro"), _c('span', [_vm._v("m the")]), _c('span'), _c('span', [_vm._v("pan.")])]), _vm._v(" "), _c('p', {
    staticClass: "body_instruction-next-para1"
  }, [_c('span', {
    staticClass: "bold1"
  }, [_vm._v("Assemble the hash")]), _vm._v(" by putting the veggie mixture on top of the cauliflower hash, add the meatballs, and top it with the fried egg"), _c('span', [_vm._v("s. Enjoy!")])]), _vm._v(" "), _c('p', {
    staticClass: "shopping-tip-centered-2col"
  }, [_c('img', {
    staticClass: "calibre3",
    attrs: {
      "alt": "",
      "src": "OEBPS/image/image-382.png"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "shopping-tip-centered-2col1"
  }, [_vm._v("There is a reason why "), _c('span', {
    staticClass: "shopping-tip-bold-red1"
  }, [_vm._v("Celtic Sea Salt®")]), _vm._v(" is in my pantry staples list for this cookbook, it’s one of the best quality salts you can cook with. Not only does it taste great thanks to the natural mineral content, it’s completely unrefined, which is not the case with that bleached white salt sitting in your pantry! Go for the Gourmet Kosher Celtic Sea Salt®, it will change your culi"), _c('span', [_vm._v("nary")]), _c('span'), _c('span', [_vm._v("life!")])]), _vm._v(" "), _c('p', {
    staticClass: "macro_macro-table-heading"
  }, [_c('span', {
    staticClass: "bold2"
  }, [_vm._v("Macros per serving (makes 2):")])]), _vm._v(" "), _c('table', {
    staticClass: "table-style",
    attrs: {
      "id": "table001"
    }
  }, [_c('colgroup', {
    staticClass: "calibre5"
  }, [_c('col', {
    staticClass: "calibre6"
  }), _vm._v(" "), _c('col', {
    staticClass: "calibre6"
  }), _vm._v(" "), _c('col', {
    staticClass: "calibre6"
  }), _vm._v(" "), _c('col', {
    staticClass: "calibre6"
  }), _vm._v(" "), _c('col', {
    staticClass: "calibre6"
  }), _vm._v(" "), _c('col', {
    staticClass: "calibre6"
  })]), _vm._v(" "), _c('tbody', {
    staticClass: "calibre7"
  }, [_c('tr', {
    staticClass: "table-style1"
  }, [_c('td', {
    staticClass: "table-style2"
  }, [_c('p', {
    staticClass: "macro_macro-table"
  }, [_vm._v("CALORIES")])]), _vm._v(" "), _c('td', {
    staticClass: "table-style2"
  }, [_c('p', {
    staticClass: "macro_macro-table"
  }, [_vm._v("NET CARBS")])]), _vm._v(" "), _c('td', {
    staticClass: "table-style2"
  }, [_c('p', {
    staticClass: "macro_macro-table"
  }, [_vm._v("TOTAL CARBS")])]), _vm._v(" "), _c('td', {
    staticClass: "table-style2"
  }, [_c('p', {
    staticClass: "macro_macro-table"
  }, [_vm._v("FAT")])]), _vm._v(" "), _c('td', {
    staticClass: "table-style2"
  }, [_c('p', {
    staticClass: "macro_macro-table"
  }, [_vm._v("PROTEIN")])]), _vm._v(" "), _c('td', {
    staticClass: "table-style2"
  }, [_c('p', {
    staticClass: "macro_macro-table"
  }, [_vm._v("FIBER")])])]), _vm._v(" "), _c('tr', {
    staticClass: "table-style1"
  }, [_c('td', {
    staticClass: "table-style2"
  }, [_c('p', {
    staticClass: "macro_macro-table"
  }, [_vm._v("450cal")])]), _vm._v(" "), _c('td', {
    staticClass: "table-style2"
  }, [_c('p', {
    staticClass: "macro_macro-table"
  }, [_vm._v("7g")])]), _vm._v(" "), _c('td', {
    staticClass: "table-style2"
  }, [_c('p', {
    staticClass: "macro_macro-table"
  }, [_vm._v("15.6g")])]), _vm._v(" "), _c('td', {
    staticClass: "table-style2"
  }, [_c('p', {
    staticClass: "macro_macro-table"
  }, [_vm._v("30.3g")])]), _vm._v(" "), _c('td', {
    staticClass: "table-style2"
  }, [_c('p', {
    staticClass: "macro_macro-table"
  }, [_vm._v("28.6g")])]), _vm._v(" "), _c('td', {
    staticClass: "table-style2"
  }, [_c('p', {
    staticClass: "macro_macro-table"
  }, [_vm._v("8.6g")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "macro_macro-table"
  }), _vm._v(" "), _c('div', {
    staticClass: "calibre1",
    attrs: {
      "id": "calibre_pb_58"
    }
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-338d27af","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/OEBPS/5Ingredient_split_035.vue
// module id = 162
// module chunks = 0